import { createFileRoute, useRouter } from '@tanstack/react-router'

import { GridItem } from '@masterplandev/ui'

import { ContainerFullViewport } from '@/core/components/ui/ContainerFullViewport/ContainerFullViewport'
import { TopicSection } from '@/topic/components/TopicSection/TopicSection'

export const Route = createFileRoute(
  '/_learning/discover/channels/$channel/view/$topic',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { channel, topic: topicSlug } = Route.useParams()
  const router = useRouter()
  const returnUrl = router.buildLocation({
    to: '/discover/channels/$channel',
    params: { channel },
  }).href

  return (
    <GridItem gridColumn="1 / -1">
      <ContainerFullViewport left="50%" transform="translateX(-50%)">
        <TopicSection
          lectureContext="channel"
          returnUrl={returnUrl}
          topicSlug={topicSlug}
        />
      </ContainerFullViewport>
    </GridItem>
  )
}
